import {LiveCasinoNavbarScrollDefaultBox} from "./live-casino-navbar-scroll.default.box";

export const LiveCasinoNavbarScrollBox = LiveCasinoNavbarScrollDefaultBox;